// extracted by mini-css-extract-plugin
export var growableInput = "_43-0";
export var tagContainer = "_43-2";
export var textInput = "_43-1";